import { ApiManager } from '../../core/api-manager';
import { DataManager } from '../../core/data-manager';
import { settings } from '../../config/settings';
import { LanguageProvider } from '../../core/language-provider';
import { toast } from 'react-toastify';



export const actions = {
    DataGridRow: {
        sample: [
            {
                label: "Test",
                icon: "share",
                func: test
            }
        ],
        gyv_customer_order: [
            {
                label: "Anteprima",
                icon: "print",
                func: customerOrderPreview
            }
        ],
        gyv_supplier_order: [
            {
                label: "Anteprima",
                icon: "print",
                func: supplierOrderPreview
            }
        ],
        gyv_customer_offer: [
            {
                label: "Anteprima",
                icon: "print",
                func: customerOfferPreview
            }
        ],
    },
    ModalDetailsFooter: {
        sample: [
            {
                label: "Test",
                icon: "share",
                func: test
            }
        ],
        gyv_customer_order: [
            {
                label: "Anteprima",
                icon: "print",
                func: customerOrderPreview
            }
        ],
        gyv_supplier_order: [
            {
                label: "Anteprima",
                icon: "print",
                func: supplierOrderPreview
            }
        ],
        gyv_customer_offer: [
            {
                label: "Anteprima",
                icon: "print",
                func: customerOfferPreview
            }
        ]
    }
}

function test(item) {
    console.warn("test", item)
}

function customerOrderPreview(item, navigate) {
    navigate('/page/CustomerOrderPreview?id=' + item.id)
}

function customerOfferPreview(item, navigate) {
    navigate('/page/CustomerOfferPreview?id=' + item.id)
}


function supplierOrderPreview(item, navigate) {
    navigate('/page/SupplierOrderPreview?id=' + item.id)
}